export default __webpack_public_path__ + "static/electrico-f504ab826852b008278840be4557650a.png";